const userTypes = {
  1: 'Fund',
  2: 'Investor',
  3: 'Service Provider',
  4: 'iConnections',
  5: 'Speaker',
  6: 'Guest',
  7: 'Media',
  8: 'Other',
  9: 'NFT',
  10: 'Student/Retired',
};

// Set the paths that should initialize pendo even if user is not logged in / anonymous
const allowedInitializePaths = [
  /roadshows/,
];

const init = (userInfo) => {
  if (window.pendo && process.env.PENDO_KEY) {
    let initializeOptions = {};
    if (Object.keys(userInfo).length > 0) {
      initializeOptions = {
        visitor: {
          id: userInfo.ContactGUID.toLowerCase(),
          contactid: userInfo.ContactID,
          email: userInfo.Email,
          full_name: `${userInfo.FirstName} ${userInfo.LastName}`,
          user_type: userTypes[userInfo.CompanyTypeID],
          subscriber: typeof userInfo.Subscriber === 'string' ? userInfo.Subscriber === 'true' : userInfo.Subscriber,
        },
        account: {
          id: userInfo.CompanyID,
          name: userInfo.CompanyName,
          companytype: userInfo.CompanyTypeID,
        },
      };
    }

    // Initialize pendo if user is logged in or on allowed paths
    const shouldInitialize = allowedInitializePaths.some((r) => r.test(window.location.pathname));
    if (Object.keys(userInfo).length > 0 || shouldInitialize) {
      window.pendo.initialize(initializeOptions);
    }
  }
};

const sendEvent = (event, payload) => {
  if (!process.env.PENDO_KEY || !window.pendo) { return; }
  window.pendo.track(event, payload);
};

export default {
  sendEvent,
  init,
};
